import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { tagsCrudConfig } from "../consts";

export const {
  fetchAllActionFactory: fetchAllTagsActionFactory,
  createActionFactory: createTagActionFactory,
  updateActionFactory: updateTagActionFactory,
  deleteActionFactory: deleteTagActionFactory
} = makeCrudStateActionFactories(tagsCrudConfig);
